<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion
        id="accordion"
        [multiple]="false"
      >
        <p-accordionTab
          header="{{ 'POLITICASDURAS.LBL_CRITERIOS' | translate }}"
          [selected]="tabSeleccionado === 'INFO'"
        >
          <form
            *ngIf="formulario"
            [formGroup]="formulario"
            (ngSubmit)="onSubmit()"
            novalidate
            id="fPoliticaDura"
            name="fPoliticaDura"
          >
            <div class="grid form-group">
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <label
                    >*
                    {{
                      "POLITICASDURAS.LBL_POLITICAS" | translate
                    }}</label
                  >
                    <p-dropdown disableTab
                      id="idPoliticasDuras"
                      name="nomPoliticasDuras"
                      [options]="selectPoliticasDuras"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                      formControlName="idTipoPoliticaDura"
                      (onChange)="validarRequeridos()" *ngIf=" !policaDura?.idPoliticaDura"
                    ></p-dropdown>
                  <label class="falso-combo-texto"
                         *ngIf="policaDura?.idPoliticaDura">{{ policaDura?.tipoPoliticaDura }}</label>
                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idTipoPoliticaDura.invalid"
                    >
                      {{
                        "POLITICASDURAS.LBL_POLITICAS" | translate
                      }}
                      {{ "LBL_REQUERIDO" | translate }}
                    </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6" *ngIf="codigoValidacion === 'PARAMETROS'">
                <div class="div-form">
                  <label>* {{ "POLITICASDURAS.LBL_PARAMETROS" | translate }}</label>
                  <input
                    type="text"
                    pInputText
                    id="parametro"
                    name="nomParametro"
                    autocomplete="off"
                    formControlName="parametro"
                    maxlength="13"
                    numero-entero-reactive
                  />
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.parametro.invalid"
                  >
                    {{ "POLITICASDURAS.LBL_PARAMETROS" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-3 lg:col-3" *ngIf="codigoValidacion === 'EDADMIN'">
                <div class="div-form">
                  <label>{{ "ESTRUCTURAAGRICOLACICLO.LBL_EDADMINIMA" | translate }}</label>
                  <input
                    [ngClass]="{'bordeRojo':(submitted && (f.edadMin.hasError('rangoInvalido') || formulario.hasError('rangoInvalido')))}"
                    type="text"
                    pInputText
                    id="edadMin"
                    name="nomedadMin"
                    autocomplete="off"
                    formControlName="edadMin"
                    maxlength="13"
                    numero-entero-reactive
                    (input)="formulario.updateValueAndValidity()"
                  />
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && (f.edadMin.hasError('rangoInvalido') || formulario.hasError('rangoInvalido'))"
                  >
                    {{ "POLITICASDURAS.LBL_VALORNOPERMITIDO" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-3 lg:col-3" *ngIf="codigoValidacion === 'EDADMIN'">
                <div class="div-form">
                  <label>{{ "ESTRUCTURAAGRICOLACICLO.LBL_EDADMAXIMA" | translate }}</label>
                  <input
                    type="text"
                    pInputText
                    id="edadMax"
                    name="nomedadMax"
                    autocomplete="off"
                    formControlName="edadMax"
                    maxlength="13"
                    numero-entero-reactive
                    (input)="formulario.updateValueAndValidity()"
                  />
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6" *ngIf="codigoValidacion === 'TIPDOC'">
                <div class="div-form">
                  <label
                    >*
                    {{
                      "POLITICASDURAS.LBL_TIPOSDOCUMENTOS" | translate
                    }}</label
                  >
                    <p-dropdown disableTab
                      id="idTiposDocumentos"
                      name="nomTiposDocumentos"
                      [options]="lisTiposDocumentos"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                      formControlName="idListaParametro"
                    ></p-dropdown>
                    <div
                      class="p-message p-messages-error p-corner-all"
                      *ngIf="submitted && f.idListaParametro.invalid"
                    >
                      {{
                        "POLITICASDURAS.LBL_TIPOSDOCUMENTOS" | translate
                      }}
                      {{ "LBL_REQUERIDO" | translate }}
                    </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4" *ngIf="codigoValidacion === 'CIUNAPLI'">
                <div class="div-form">
                  <label>*{{ 'LOCALIZACIONES.LBL_CIUDAD' | translate }}</label>
                  <p-autoComplete placeholder="Buscar ciudad" optionLabel="camino" name="camino" id="camino" formControlName="camino"
                                  [suggestions]="hoodList" required="true" (completeMethod)="hoodSearch($event)"
                                  [forceSelection]="true" [minLength]="3"
                                  (onSelect)="captureHoodId($event); captureHoodIdCiudad($event)"
                                  emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                  showEmptyMessage="true">
                  </p-autoComplete>
                  <div
                    class="mt-2 flex flex-wrap gap-2"
                    *ngFor="let ciudad of ciudadesSeleccionadas">
                    <label class="falso-combo-texto flex items-center justify-between gap-2 bg-gray-200 text-gray-800 px-3 py-1 rounded-full">
                      <span>{{ ciudad.camino }}</span>
                      <button
                        type="button"
                        (click)="eliminarCiudad(ciudad)"
                        pButton
                        class="p-button-rounded p-button-text p-button-danger"
                        title="{{ 'BTN_ELIMINAR' | translate }}"
                        icon="fa fa-trash">
                      </button>
                    </label>
                  </div>

                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idDivisionPolitica.invalid">
                    <i class="fa fa-close"></i> {{ 'LOCALIZACIONES.LBL_CIUDAD' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4" *ngIf="codigoValidacion === 'CIUNAPLI'">
                <div class="div-form">
                  <button
                    type="button"
                    pButton
                    icon="fa fa-floppy-o"
                    (click)="crearCiudades()"
                    label="{{ 'BTN_AGREGAR' | translate }}"
                  ></button>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4" *ngIf="codigoValidacion === 'BARPROD'">
                <div class="div-form">
                  <label for="barriov">*{{ 'LOCALIZACIONES.LBL_BARRIOVEREDA' | translate }}</label>
                  <p-dropdown disableTab  id="barriov" name="barriov" [options]="listNeighborhoods"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                               required="true" filter="filter"
                              formControlName="idDivisionPolitica" (onChange)="changeBarrio($event)"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idDivisionPolitica.invalid">
                    <i class="fa fa-close"></i> {{ 'LOCALIZACIONES.LBL_BARRIO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-footer-buttons" *ngIf="codigoValidacion !== 'CIUNAPLI'">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{
                    "BTN_CANCELAR" | translate
                  }}</a>
                  <button
                    icon="fa fa-floppy-o"
                    label="{{ 'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton
                  ></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
                  <span>{{ "LBL_GUARDANDO" | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
      </p-accordion>
      <div
        class="grid form-footer-buttons"
      >
        <div class="form-group col-12">
          <button
            icon="fa fa-arrow-left"
            label="{{ 'BTN_REGRESAR' | translate }}"
            type="button"
            pButton
            (click)="regresar(false)"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="codigoValidacion === 'CIUNAPLI'">
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              [(ngModel)]="busqueda" (change)="setSearch()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        [loading]="carPoliticasDuras"
        #dt
        [value]="politicasDurasDivisionesPoliticas"
        selectionMode="single"
        dataKey="idPoliticasDuras"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.camino }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_ELIMINAR' | translate }}"
                  pButton
                  (click)="eliminarPoliticaDuraDivisionPolitica(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
